import { number, object, string } from 'yup';

const position2dSchema = object({
    x: number().required(),
    y: number().required(),
});

const scale2dSchema = object({
    x: number().required(),
    y: number().required(),
});

const size2dSchema = object({
    height: number().required(),
    width: number().required(),
});

const sideSchema = string()
    .oneOf(['recto', 'verso'] as const)
    .required();

export { position2dSchema, scale2dSchema, sideSchema, size2dSchema };
